import type { SelectorObj } from '../../shared.types'
import type { DomApplier } from '../cssFeatures.types'
import { getVariantSelectors, variantsComparator } from '../../utils/variantsUtils'

export const svgBackgroundImageDomApplier: DomApplier<'svgBackgroundImage'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ svgBackgroundImage },
	cssContext
) => {
	const data = svgBackgroundImage?.data
	const variants = svgBackgroundImage?.variants || null

	if (!data) {
		return null
	}

	const cssInBreakpoint = data[breakpointId]
	if (!cssInBreakpoint) {
		return null
	}

	return Object.entries(cssInBreakpoint)
		.sort(variantsComparator(variants!))
		.reduce<SelectorObj>((acc, [variantKey, cssObj]) => {
			if (!cssObj) {
				return acc
			}

			const variantSelectors = getVariantSelectors(variantKey, variants, compId, cssContext)

			for (const element in cssObj) {
				const finalSelector = `${variantSelectors} ${element}`
				acc[finalSelector] = Object.assign(acc[finalSelector] || {}, cssObj[element as keyof typeof cssObj])
			}
			return acc
		}, {})
}
